import {RolesAccount, RoleType} from '@/app/auth/constants/AuthConstants';

export function isRoleType(value: unknown): value is RoleType {
  return (
    typeof value === 'string' &&
    Object.values(RolesAccount).includes(value as RoleType)
  );
}
